<template>
  <div
    v-if="!currentUser || !currentUser.id"
    class="container-form-login-google"
  >
    <aha-antd-button
      variant="primary-alt"
      size="lg"
      block
      @click="redirectToPresenterAppPage"
    >
      {{ $t('login') }}
    </aha-antd-button>

    <div class="separator my-6" v-if="settingShowSeparator" :class="{'dark': isTextColourLight}">
      &nbsp;{{ $t('or') }}&nbsp;
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import config from '@/config'
import constant from '@/constant'

export default {
  name: 'ContainerLoginGoogle',
  props: {
    showSeparator: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      showButtonLogin: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      textColour: (_, getters) => getters.activeActivity.textColour,
    }),
    ...mapGetters('themeModule', ['isTextColourLight']),
    isWhiteLabelUser() {
      return window.location.host !== config.domain
    },
    settingShowSeparator() {
      if (!this.showSeparator) {
        return false
      }
      if (this.isWhiteLabelUser) {
        return false
      }
      if (config.region === constant.euRegion) {
        return false
      }
      return this.$route.query.fromIframe !== 'true'
    },
  },
  methods: {
    redirectToPresenterAppPage() {
      const redirect = window.location.href
      window.location.href = `${config.presenterUrl}/pages/login?from=audience&redirect=${encodeURIComponent(redirect)}`
    },
  },
}
</script>

<style lang="scss" scoped>

.separator {
  --tw-text-opacity: 1;
  color: rgba(75, 75, 75, var(--tw-text-opacity));
  display: flex;
  align-items: center;
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  text-transform: uppercase;

  &.dark {
    color: rgba(255, 255, 255, 1);
    &::before, &::after{
      border-color: rgb(104,104,104);
    }
  }
}

.separator::before,
.separator::after {
  content: "";
  flex: 1;
}

.separator::before,
.separator::after {
  border-bottom-width: 0;
  --tw-border-opacity: 1;
  border-color: rgba(235, 235, 235, var(--tw-border-opacity));
  border-style: solid;
}

.separator::before{
  margin-right: 12px;
}

.separator::after{
  margin-left: 12px;
}
</style>
